export default {
  root: {
    paddingTop: 8,
    paddingLeft: 0,
    paddingBottom: 0,
    paddingRight: 0
  }
}
